import { graphql } from '@eluve/graphql.tada';

export const tenantUserRoleFragment = graphql(`
  fragment tenantUserRole on TenantUsers @_unmask {
    __typename
    tenantId
    userId
    role
  }
`);

export const updateUserTenantRoleMutation = graphql(`
  mutation updateUserTenantRole(
    $tenantId: uuid!
    $userId: uuid!
    $role: String!
  ) {
    updateTenantUsersByPk(
      pkColumns: { tenantId: $tenantId, userId: $userId }
      _set: { role: $role }
    ) {
      __typename
      tenantId
      userId
      role
    }
  }
`);
